// extracted by css-extract-rspack-plugin
export default {"linkPadding":"_linkPadding_HfYhb","link":"_link_OfDOS","upgrade":"_upgrade_h8vj4","inherit":"_inherit_gCEDA","table":"_table_Fe7f1","placeholder":"_placeholder_aXbHt"};